import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import IUserMenu from '../../../interfaces/IUserMenu';

const menuStore = createSlice({
  name: 'menu',
  initialState: [] as IUserMenu[],
  reducers: {
    setMenu(_state, action: PayloadAction<IUserMenu[]>) {
      return [...action.payload];
    },
    invalidateMenu() {
      return []
    }
  },
});

export default menuStore;
export const { setMenu, invalidateMenu } = menuStore.actions;
